<template>
  <div class="quote-page">
    <!-- 顶部操作栏 -->
    <el-card class="tool-card" shadow="never">
      <div class="tool-row">
        <div class="tool-left">
          <span class="tool-title">名额申请表</span>
          <span class="tool-sub">登记名额申请记录，跟踪申请与审批状态</span>
        </div>
        <div class="tool-actions">
          <el-button icon="el-icon-view" @click="openPreview">预览</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openEdit(null)">新增申请</el-button>
        </div>
      </div>
    </el-card>

    <!-- 列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="list"
        :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }"
        empty-text="暂无名额申请"
      >
        <el-table-column prop="name" label="申请人" min-width="120" />
        <el-table-column prop="phone" label="手机号" min-width="130" />
        <el-table-column prop="content" label="申请内容" min-width="180">
          <template slot-scope="{ row }">
            <span class="content-text">{{ row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请状态" width="110" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="parseInt(row.apply_status) === 2 ? 'success' : 'warning'" size="small">{{ row.apply_status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审批状态" width="110" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="approvalType(row.approval_status)" size="small">{{ row.approval_status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否显示" width="110" align="center">
          <template slot-scope="{ row }">
            {{ row.display_text }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="150">
          <template slot-scope="{ row }">
            <span class="time-text">{{ fmtDateTime(row.createtime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="{ row }">
            <el-button v-if="isCompany" type="text" size="small" @click="openEdit(row)">编辑</el-button>
            <el-button v-if="isCompany" type="text" size="small" class="del-btn" @click="doDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="editId ? '编辑申请' : '新建申请'" :visible.sync="editVisible" width="560px">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small">
        <el-form-item label="申请人" prop="applicant">
          <el-input v-model="form.applicant" placeholder="请输入申请人" :maxlength="50" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" :maxlength="11" />
        </el-form-item>
        <el-form-item label="申请内容" prop="content">
          <el-input v-model="form.content" placeholder="请输入申请内容" :maxlength="200" />
        </el-form-item>
        <el-form-item label="申请状态">
          <el-select v-model="form.apply_status" style="width: 100%">
            <el-option label="申请中" :value="1" />
            <el-option label="申请完毕" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="form.approval_status" style="width: 100%">
            <el-option label="无" :value="0" />
            <el-option label="通过" :value="1" />
            <el-option label="拒绝" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否显示">
          <el-switch v-model="form.display" active-text="显示" inactive-text="不显示" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 预览设置弹窗 -->
    <el-dialog title="预览设置" :visible.sync="previewVisible" width="560px">
      <el-form label-width="100px" size="small">
        <el-form-item label="表格标题">
          <el-input v-model="previewForm.title" :maxlength="30" />
        </el-form-item>
        <el-form-item label="显示统计">
          <el-switch v-model="previewForm.showNum" active-text="显示" inactive-text="不显示" />
        </el-form-item>
        <template v-if="previewForm.showNum">
          <el-form-item label="总名额">
            <el-input-number v-model="previewForm.totalNum" :min="0" :max="99999999" style="width: 200px" />
          </el-form-item>
          <el-form-item label="已申请名额">
            <el-input-number v-model="previewForm.indexNum" :min="0" :max="99999999" style="width: 200px" />
          </el-form-item>
          <el-form-item label="剩余名额">
            <el-input-number v-model="previewForm.surNum" :min="0" :max="99999999" style="width: 200px" />
          </el-form-item>
        </template>
        <el-form-item label="显示列">
          <el-checkbox-group v-model="previewCols">
            <el-checkbox v-for="c in quoteCols" :key="c.key" :label="c.key">{{ c.label }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="previewVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="previewing" @click="doPreview">预览</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { quoteList, quoteSave, quoteDelete, quotePreviewUrl } from '@/api/tool'

export default {
  name: 'QuoteList',
  data() {
    return {
      list: [],
      loading: false,
      editVisible: false,
      editId: 0,
      saving: false,
      form: { applicant: '', phone: '', content: '', apply_status: 1, approval_status: 0, display: true },
      rules: {
        applicant: [
          { required: true, message: '请填写申请人', trigger: 'blur' },
          { max: 50, message: '最多 50 字', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请填写申请内容', trigger: 'blur' },
          { max: 200, message: '最多 200 字', trigger: 'blur' }
        ]
      },
      // 预览设置
      previewVisible: false,
      previewing: false,
      previewForm: { title: '名额申请表', showNum: true, totalNum: 100, indexNum: 0, surNum: 0 },
      quoteCols: [
        { key: 'name', label: '姓名' },
        { key: 'phone', label: '手机号' },
        { key: 'content', label: '申请内容' },
        { key: 'apply_status_text', label: '申请状态' },
        { key: 'approval_status_text', label: '审核结果' },
        { key: 'create_time', label: '申请时间' }
      ],
      previewCols: ['name', 'phone', 'apply_status_text', 'approval_status_text', 'create_time']
    }
  },
  created() {
    this.load()
  },
  computed: {
    isCompany() {
      const u = this.$store.state.user
      return !!u && u.type === 'company'
    }
  },
  methods: {
    load() {
      this.loading = true
      quoteList()
        .then(data => { this.list = data.list || [] })
        .catch(() => { this.list = [] })
        .finally(() => { this.loading = false })
    },
    openPreview() {
      this.previewVisible = true
    },
    doPreview() {
      if (this.previewCols.length === 0) {
        this.$message.warning('请至少勾选一列')
        return
      }
      this.previewing = true
      quotePreviewUrl({
        title: this.previewForm.title.trim() || '名额申请表',
        showNum: this.previewForm.showNum ? 1 : 0,
        totalNum: this.previewForm.totalNum,
        indexNum: this.previewForm.indexNum,
        surNum: this.previewForm.surNum,
        cols: this.previewCols
      })
        .then(data => {
          if (data.url) window.open(data.url, '_blank')
          this.previewVisible = false
        })
        .catch(() => {})
        .finally(() => { this.previewing = false })
    },
    approvalType(s) {
      s = parseInt(s)
      if (s === 1) return 'success'
      if (s === 2) return 'danger'
      return 'info'
    },
    fmtDateTime(ts) {
      if (!ts) return '—'
      const d = new Date(parseInt(ts) * 1000)
      const p = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
    openEdit(row) {
      if (row) {
        this.editId = row.id
        this.form = {
          applicant: row.name,
          phone: row.phone,
          content: row.content,
          apply_status: parseInt(row.apply_status),
          approval_status: parseInt(row.approval_status),
          display: parseInt(row.display) === 1
        }
      } else {
        this.editId = 0
        this.form = { applicant: '', phone: '', content: '', apply_status: 1, approval_status: 0, display: true }
      }
      this.editVisible = true
    },
    doSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        quoteSave({
          id: this.editId,
          applicant: this.form.applicant.trim(),
          phone: this.form.phone.trim(),
          content: this.form.content.trim(),
          apply_status: this.form.apply_status,
          approval_status: this.form.approval_status,
          display: this.form.display ? 1 : 0
        })
          .then(() => {
            this.$message.success(this.editId ? '修改成功' : '新增成功')
            this.editVisible = false
            this.load()
          })
          .catch(() => {})
          .finally(() => { this.saving = false })
      })
    },
    doDelete(row) {
      this.$confirm(`确认删除该条名额申请？`, '删除记录', {
        confirmButtonText: '删 除',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        quoteDelete(row.id)
          .then(() => {
            this.$message.success('删除成功')
            this.load()
          })
          .catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.quote-page { padding: 0; }
.tool-card { margin-bottom: 14px; border-radius: 10px; border: 1px solid #E5E9F2; }
.tool-row { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; }
.tool-left { display: flex; align-items: baseline; gap: 12px; }
.tool-title { font-size: 15px; font-weight: 700; color: #18233C; }
.tool-sub { font-size: 12px; color: #8A94AD; }
.table-card { border-radius: 10px; border: 1px solid #E5E9F2; }
.content-text { color: #5A6580; }
.time-text { color: #8A94AD; font-size: 12px; }
.del-btn { color: #E5484D; }
::v-deep .el-button--primary { background: #3668FC; border-color: #3668FC; }
::v-deep .el-button--primary:hover,
::v-deep .el-button--primary:focus { background: #5B8DFF; border-color: #5B8DFF; }
::v-deep .el-table__row:hover > td { background: #F5F8FF !important; }
::v-deep .el-dialog { border-radius: 12px; }
</style>